import React from "react";
import {IonProgressBar} from "@ionic/react";
import {formDefVeterinario} from "./forms";
import {QuestionarioVeterinarioObject} from "../../../models/Questionario";
import {EventoObject} from "../../../models/Evento";
import FieldView from "../../../components/FieldView";
import {ModelForm, ModelFormProps, ModelFormField, buildModelForm} from "../../../components/ModelFormHOC";
import fb from "../../../lib/firebase";
import {AppState} from "../../../models/app";
import {AppDispatch, RootState} from "../../../global.state";
import {connect} from "react-redux";


interface Props extends ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  evento: EventoObject | undefined;
  principal: any;
  instance?: QuestionarioVeterinarioObject;
  onSubmit: () => void;
}

class _FormQuestionarioVeterinario extends React.Component<Props> {
  // noinspection DuplicatedCode
  onCreate = (values:any) => {
    values.principal = fb.db.doc(this.props.principal.path);
    values.tipo = this.props.evento!.principal.path.parent.id;
    values.evento = {
      label: fb.eventos.label(this.props.evento!),
      path: fb.db.collection('eventos').doc(this.props.evento!.id),
    };

    return fb.document.create('questionarios', values);
  };

  onUpdate = (values:any) => {
    return fb.document.update('questionarios', this.props.instance!.id, values);
  };

  render() {
    if (!this.props.principal || !this.props.evento)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <>
        <div className="flex flex-wrap">
          <div className="flex-grow">
            <FieldView value={this.props.principal.nome} label="Veterinário"/>
          </div>
          <div className="flex-shrink">
            <FieldView value={this.props.evento.data} label="Data evento" type="date" format="DD/MM/YYYY"/>
          </div>
        </div>

        <ModelForm
          entityLabel="Questionário"
          ownerId={this.props.app.user.uid}
          gender="m"
          instance={this.props.instance}
          formDefinition={formDefVeterinario}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          onComplete={this.props.onSubmit}
        >
          <ModelFormField
            field="produtos_abordados"
            options={['Bovigen Repro Total', 'Bovigen Lepto 8', 'Bovigen V4J5', 'Fosfosal']}
          />
          <ModelFormField field="observacoes"/>
        </ModelForm>
      </>
    )
  }
}

export const FormQuestionarioVeterinario = connect(({app}: RootState) => ({app}))(buildModelForm(_FormQuestionarioVeterinario));
